import { render, staticRenderFns } from "./ScrollCarousel.vue?vue&type=template&id=df95c570&scoped=true"
import script from "./ScrollCarousel.vue?vue&type=script&lang=js"
export * from "./ScrollCarousel.vue?vue&type=script&lang=js"
import style0 from "./ScrollCarousel.vue?vue&type=style&index=0&id=df95c570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95c570",
  null
  
)

export default component.exports